// import jsrsasign from 'jsrsasign'
import $http from '@/module/http'
import { getPermission } from '@/permission'
import dayjs from 'dayjs'
import i18n from '../../i18n'

// 格式化每小时花费显示
const formatHourly = (val) => {
  if (val === null || val === undefined || val === '') return '—'
  const num = Number(val)
  if (Number.isNaN(num)) return '—'
  // return `$${num}/hr`
  return i18n.t('unit.currency', [`${num}`]) + '/' + i18n.tc('unit.hour', 1)
}

const sevenDaysMs = 7 * 24 * 60 * 60 * 1000

let info = null
let countries = null
let validatearr = getPermission(['account.information.bind_phone'])
  ? ['phone_number']
  : ['email', 'first_name', 'country', 'state', 'city', 'address1', 'postcode']
export default {
  strict: true,
  namespaced: true,
  state: {
    isNewClient: false,
    unpaid: 0,
    upgradeInfo: null,
    spendRateLimit: null,
    clientInfo: {
      id: ''
    }
  },
  getters: {
    checkInfoCompleted: (state) => {
      return () => {
        if (getPermission(['billing.information.validate'])) {
          let arr = Object.keys(state.clientInfo)
          let flag = true
          arr.map((key) => {
            if (validatearr.indexOf(key) !== -1 && !state.clientInfo[key]) {
              flag = false
            }
          })
          return flag
        } else {
          return true
        }
      }
    },
    isPendingReview: (state, getters) => {
      const client = state.clientInfo
      const verification = client.verification_info
      return (
        client.status === 'Uncertain' &&
        client.sub_status === 'Restricted' &&
        getters.checkInfoCompleted() &&
        (verification === null || (!!verification && verification.need_verify === false))
      )
    },
    needVerify: (state) => {
      if (state.clientInfo) {
        let sub_status = state.clientInfo.sub_status
        return state.clientInfo.status === 'Uncertain' && sub_status === 'Restricted'
      }
      return false
    },
    hasVerificationEnabled: (state) => {
      const v = state.clientInfo.verification_info
      if (!v) return false
      return (
        v.identity_enabled ||
        v.company_enabled ||
        v.credit_card_enabled ||
        v.email_enabled ||
        v.paypal_enabled ||
        v.transaction_enabled
      )
    },
    showUpgrade: (state) => {
      if (!state.upgradeInfo || state.upgradeInfo.count === 0) {
        return false
      } else {
        let info = state.upgradeInfo.results[0]
        const last = dayjs(info.last_updated)
        return dayjs().diff(last, 'millisecond') < sevenDaysMs
      }
    },
    spendRateLimitDisplay: (state) => {
      if (!state.spendRateLimit) {
        return '--'
      } else {
        if (state.spendRateLimit.sub_status === 'Normal') {
          return 'No limit'
        } else {
          return formatHourly(state.spendRateLimit.spend_limit)
        }
      }
    }
  },
  mutations: {
    setClientInfo(state, payload) {
      state.clientInfo = payload
    },
    setSpendRateLimit(state, payload) {
      state.spendRateLimit = payload
    }
  },
  /**
   * @params  flag  {Boolean} whether force to refresh info
   * */
  actions: {
    getClientInfo: ({ rootState, commit }, flag) => {
      if (!flag && info) {
        return info
      }
      if (rootState.oAuth.clientId === -1) {
        let res = { id: -1 }
        commit('setClientInfo', res)
        info = Promise.resolve(res)
      } else {
        info = $http.get(`/clients/${rootState.oAuth.clientId}/`).then((res) => {
          commit('setClientInfo', res)
        })
      }
      return info
    },
    getCountries: () => {
      if (!countries) {
        countries = $http
          .get(`/countries/`, {
            params: {
              page_size: 300
            }
          })
          .then((res) => {
            return Promise.resolve(res.results)
          })
      }
      return countries
    },
    getUnPaid: ({ state, commit }) => {
      return $http
        .get('/invoices/', {
          params: {
            client_id: state.clientInfo.id,
            page_size: 999,
            q: 'status=Unpaid'
          }
        })
        .then((res) => {
          commit(
            'setState',
            {
              module: 'client',
              payload: {
                unpaid: res.total
              }
            },
            { root: true }
          )
          return Promise.resolve(res.total)
        })
    },
    getFreeTrialStatus: () => {
      return $http({
        method: 'get',
        url: `/clients/status/`
      })
    },
    getCredit() {
      return $http.get(`/client_credit_transactions/current_credit/`)
    },
    getUpgradeInfo({ commit }) {
      return $http.get('/clients/upgrade_account/').then((res) => {
        commit('setState', { module: 'client', payload: { upgradeInfo: res } }, { root: true })
        return res
      })
    },
    getSpendRateLimit({ commit }) {
      return $http.get(`/clients/spend_rate_limit/`).then((res) => {
        commit('setSpendRateLimit', res)
        return res
      })
    }
  }
}
